import type { ReactNode } from "react";

import { MenuItem } from "@skilitics/designer-ui-components";

import { useSlotCopyClipboard } from "../../../slots";
import type { DesignerNode } from "../../../types";

interface Props {
  node: DesignerNode;
  children: ReactNode;
}

export const CopyMenuItem = ({ node, children }: Props) => {
  const { copy } = useSlotCopyClipboard();
  return <MenuItem onClick={() => copy({ slotResidentNodeId: node.id })}>{children}</MenuItem>;
};
